import InputField from "./inputField";
import { HeroButton } from "./button";
import FileUpload from "./FileUpload";

const SupplierRegistrationForm = () => {
  return (
    <div className="mt-6 md:mt-12 bg-white rounded-[12px] md:rounded-[24px] px-5 md:px-10 lg:px-[100px] py-5 md:py-10 lg:py-20 space-y-6 md:space-y-8 w-full">
      <div className="flex flex-col gap-6 md:flex-row">
        <InputField
          label="Company Name"
          placeholder="Enter your company name"
        />
        <InputField
          label="Trade License Number"
          placeholder="Enter your trade license number"
          type="number"
        />
      </div>
      <div className="flex flex-col gap-6 md:flex-row">
        <InputField
          label="Email Address"
          placeholder="Enter your email address"
          type="email"
        />
        <InputField
          label="Phone Number"
          placeholder="Enter your phone number"
          type="tel"
        />
      </div>
      <div className="flex flex-col gap-6 md:flex-row">
        <InputField
          label="Primary Contact Person"
          placeholder="Enter your primary contact person"
          type="tel"
        />
        <InputField
          label="Supplier Category"
          placeholder="Select your supplier category"
          as="select"
          options={[
            { label: "Residential", value: "Residential" },
            { label: "Business", value: "Business" },
          ]}
        />
      </div>
      <div className="flex flex-col gap-6 md:flex-row">
        <InputField
          label="Product/Service Description"
          placeholder="Enter your product/service description"
          as="textarea"
          className="h-[127px]"
        />
      </div>

      <FileUpload
        label=" Upload Documents (Trade License, Certificates, Portfolio, etc.)"
        description=" Upload Documents (Trade License, Certificates, Portfolio, etc.)"
        accept=".pdf,.doc,.docx, jpeg, png"
        maxSize={10}
        size="large"
        onChange={(file) => console.log(file)}
      />

      <div className="flex items-center gap-2 md:gap-3 lg:gap-4">
        <input
          type="checkbox"
          id="terms-checkbox"
          className="w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 appearance-none bg-white border-2 border-[#F03813] rounded-[4px] cursor-pointer checked:bg-[#F03813] checked:border-[#F03813] relative checked:after:content-['✓'] checked:after:absolute checked:after:top-1/2 checked:after:left-1/2 checked:after:transform checked:after:-translate-x-1/2 checked:after:-translate-y-1/2 checked:after:text-white checked:after:text-[10px] md:checked:after:text-xs lg:checked:after:text-sm checked:after:font-bold"
        />
        <label
          htmlFor="terms-checkbox"
          className="text-sm md:text-base lg:text-lg font-normal text-[#0A0E2EBF] cursor-pointer leading-relaxed"
        >
          I confirm all information provided is accurate
        </label>
      </div>
      <div className="flex justify-center pt-5">
        <HeroButton title="Submit Application" />
      </div>
    </div>
  );
};

export default SupplierRegistrationForm;
